export const getNsoOrderStatusLabel = (status) => {
    const labels = {
        ricevuto: 'Ricevuto',
        preso_in_carico: 'Preso in carico',
        evaso: 'Evaso',
        rifiutato: 'Rifiutato',
    };
    return labels[status] || status;
};

export const getNsoOrderStatusColor = (status) => {
    const colors = {
        ricevuto: 'default',
        preso_in_carico: 'processing',
        evaso: 'success',
        rifiutato: 'error',
    };
    return colors[status] || 'default';
};

export const getPraticaAslStatusLabel = (status) => {
    const labels = {
        ordine_ricevuto: 'Ordine ricevuto',
        in_prova: 'In prova',
        consegnato: 'Consegnato',
        fatturato: 'Fatturato',
        pagato: 'Pagato',
        aperta: 'Aperta',
        in_fatturazione: 'In fatturazione',
        archiviata: 'Archiviata',
        rifiutata: 'Rifiutata',
    };
    return labels[status] || status;
};

export const getPraticaAslStatusColor = (status) => {
    const colors = {
        ordine_ricevuto: 'default',
        in_prova: 'cyan',
        consegnato: 'blue',
        fatturato: 'gold',
        pagato: 'success',
        aperta: 'warning',
        in_fatturazione: 'processing',
        archiviata: 'default',
        rifiutata: 'error',
    };
    return colors[status] || 'default';
};

export const PRATICA_ASL_LIFECYCLE = [
    { key: 'ordine_ricevuto', label: 'Ordine ricevuto' },
    { key: 'in_prova', label: 'In prova' },
    { key: 'consegnato', label: 'Consegnato' },
    { key: 'fatturato', label: 'Fatturato' },
    { key: 'pagato', label: 'Pagato' },
];

export const getPraticaAslLifecycleStep = (status) => {
    const index = PRATICA_ASL_LIFECYCLE.findIndex((s) => s.key === status);
    return index >= 0 ? index : -1;
};

export const getFatturaPAStatusLabel = (status) => {
    const labels = {
        bozza: 'Bozza',
        inviata_sdi: 'Inviata SDI',
        accettata: 'Accettata',
        rifiutata: 'Rifiutata',
        decorrenza_termini: 'Decorrenza termini',
    };
    return labels[status] || status;
};

export const getFatturaPAStatusColor = (status) => {
    const colors = {
        bozza: 'default',
        inviata_sdi: 'processing',
        accettata: 'success',
        rifiutata: 'error',
        decorrenza_termini: 'warning',
    };
    return colors[status] || 'default';
};

export const getStsExportStatusLabel = (status) => {
    const labels = {
        bozza: 'Bozza',
        pronta_export: 'Pronta export',
        inviata: 'Inviata',
    };
    return labels[status] || status;
};

export const getStsExportStatusColor = (status) => {
    const colors = {
        bozza: 'default',
        pronta_export: 'purple',
        inviata: 'success',
    };
    return colors[status] || 'default';
};

export const DICITURA_DISPOSITIVO_MEDICO =
    'Dispositivo medico ai sensi del Regolamento UE 2017/745 – Spesa detraibile ai sensi dell\'art. 15, co. 1, lett. c) del TUIR';

export const buildStsLightCsvContent = (stsExport) => {
    if (!stsExport) return '';
    const header = 'Paziente;Codice Fiscale;Importo;Data;Detraibile';
    const rows = (stsExport.entries || []).map((e) =>
        [e.patientName, e.patientCf, e.amount, e.date, e.deductible ? 'SI' : 'NO'].join(';')
    );
    return [
        `# Report STS light – ${stsExport.period}`,
        `# Totale voci: ${stsExport.totalEntries} – Totale importo: ${stsExport.totalAmount}`,
        `# Stato: ${stsExport.status}`,
        '',
        header,
        ...rows,
    ].join('\n');
};

export const getAccountantExportTypeLabel = (type) => {
    const labels = {
        sts_trimestrale: 'STS trimestrale',
        sts_light: 'Report STS light',
        pratiche_asl: 'Pratiche ASL',
        fatture_pa: 'Fatture PA',
        riepilogo_annuale: 'Riepilogo annuale',
    };
    return labels[type] || type;
};

export const getAccountantExportStatusLabel = (status) => {
    const labels = {
        pronto: 'Pronto',
        inviato: 'Inviato',
    };
    return labels[status] || status;
};

export const getQuotaResiduaCaricoLabel = (tipo) => {
    const labels = {
        cittadino: 'A carico del cittadino',
        riconducibile: 'Riconducibile (terzo payer)',
    };
    return labels[tipo] || tipo || '—';
};

export const getQuotaResiduaCaricoColor = (tipo) => {
    const colors = {
        cittadino: 'blue',
        riconducibile: 'purple',
    };
    return colors[tipo] || 'default';
};

export const getAccountantExportStatusColor = (status) => {
    const colors = {
        pronto: 'warning',
        inviato: 'success',
    };
    return colors[status] || 'default';
};

export const recalculateComplianceWorkspace = (workspace) => {
    if (!workspace) return workspace;

    const nsoOrders = workspace.nsoOrders || [];
    const pratiche = workspace.pratiche || [];
    const fatturePA = workspace.fatturePA || [];
    const stsExports = workspace.stsExports || [];

    return {
        ...workspace,
        summary: {
            nsoOrders: {
                total: nsoOrders.length,
                daEvadere: nsoOrders.filter((o) => ['ricevuto', 'preso_in_carico'].includes(o.status)).length,
                evasi: nsoOrders.filter((o) => o.status === 'evaso').length,
            },
            pratiche: {
                total: pratiche.length,
                ordineRicevuto: pratiche.filter((p) => p.status === 'ordine_ricevuto').length,
                inProva: pratiche.filter((p) => p.status === 'in_prova').length,
                consegnate: pratiche.filter((p) => p.status === 'consegnato').length,
                fatturate: pratiche.filter((p) => p.status === 'fatturato').length,
                pagate: pratiche.filter((p) => p.status === 'pagato').length,
                aperte: pratiche.filter((p) => p.status === 'aperta').length,
                inFatturazione: pratiche.filter((p) => p.status === 'in_fatturazione').length,
            },
            fatturePA: {
                total: fatturePA.length,
                bozze: fatturePA.filter((f) => f.status === 'bozza').length,
                inviate: fatturePA.filter((f) => f.status === 'inviata_sdi').length,
                accettate: fatturePA.filter((f) => f.status === 'accettata').length,
                totalAmount: fatturePA
                    .filter((f) => ['inviata_sdi', 'accettata', 'decorrenza_termini'].includes(f.status))
                    .reduce((sum, f) => sum + Number(f.amount || 0), 0),
            },
            stsExports: {
                total: stsExports.length,
                pronti: stsExports.filter((s) => s.status === 'pronta_export').length,
                inviati: stsExports.filter((s) => s.status === 'inviata').length,
            },
        },
    };
};
